module.exports = __webpack_public_path__ + "img/cool-icon-white.92e76952.svg";